import { atom } from "recoil";

// KP全医療機関マスタの受入実績有りの中間テーブル
export const availableState = atom({
  key: "availableState",
  default: {
    id: null,
    hospital_id: null,
    corporation_id: null,
    corporation_name: '',
    insurances: [],
    using_insurance_ids: [],
  },
});